import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Trigger deployment Tue Oct  7 12:06:34 IST 2025
// Frontend deployment trigger Tue Oct  7 12:37:01 IST 2025
// Frontend deployment trigger Tue Oct  7 13:33:14 IST 2025
// Force deployment Wed Oct  8 22:09:05 IST 2025
// Force deployment Wed Oct  8 22:14:19 IST 2025
